// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3ySb9","info":"PatientInfo_info__WOze6"};